module.exports = __webpack_public_path__ + "static/media/adb_color.9face58d.jpg";